import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function cancelSendDaysCourtesyAEAT (params = null, data = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getCompany)
    })
  } else {
    const req = {
      url: 'api/cifsempresa/cancelarsolicitudvacaciones',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params,
      data,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { cancelSendDaysCourtesyAEAT }
